// Global tap haptics — fires a tiny vibration whenever the user taps a
// button, link, select or role=button element. Uses the Capacitor Haptics
// plugin on the device; falls back to navigator.vibrate(10) on Android web.
// Honours a kh_haptics_off localStorage flag so power users can disable.
import { Capacitor } from "@capacitor/core";

let lastAt = 0;

function selectorFor(el) {
  if (!el || !el.closest) return null;
  return el.closest("button, a, [role='button'], label, .haptic-tap, input[type='checkbox'], input[type='radio']");
}

async function fireNative() {
  try {
    const mod = await import("@capacitor/haptics");
    await mod.Haptics.impact({ style: mod.ImpactStyle.Light });
  } catch { /* plugin missing — ignore */ }
}

export function initGlobalHaptics() {
  if (typeof window === "undefined") return;
  const handler = (e) => {
    if (localStorage.getItem("kh_haptics_off") === "1") return;
    const now = performance.now();
    if (now - lastAt < 60) return;
    lastAt = now;
    const target = selectorFor(e.target);
    if (!target) return;
    if (Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
      fireNative();
    } else if (navigator.vibrate) {
      try { navigator.vibrate(10); } catch { /* some browsers block */ }
    }
  };
  // pointerdown fires on both mouse + touch, before the click → feels natural
  window.addEventListener("pointerdown", handler, { passive: true, capture: true });
}
